"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterPerHour = exports.KilometerPerHour = exports.MilesPerHour = exports.FeetPerMinute = exports.FeetPerSecond = exports.MeterPerSecond = void 0;
var uom_1 = require("uom");
exports.MeterPerSecond = uom_1.UnitFormat.createUnitFormat("m/s", 2);
exports.FeetPerSecond = uom_1.UnitFormat.createUnitFormat("ft/s", 0);
exports.FeetPerMinute = uom_1.UnitFormat.createUnitFormat("ft/min", 0);
exports.MilesPerHour = uom_1.UnitFormat.createUnitFormat("mph", 0);
exports.KilometerPerHour = uom_1.UnitFormat.createUnitFormat("km/h", 0);
exports.MeterPerHour = uom_1.UnitFormat.createUnitFormat("m/h", 0);
//# sourceMappingURL=velocity-format.js.map